import React from "react";
import { router } from "dva";
import { Information } from "./information";
import { InformationDetails } from "./information.details";

export { Information, InformationDetails };

export const routes = ({ match }) => (
    <router.Route
        path={match.path}
        render={({ match }) => (
            <>
                <router.Route exact path={`${match.path}`} component={Information.Page} />
                <router.Route exact path={`${match.path}/details/:id`} component={InformationDetails.Page} />
                <router.Route exact path={`${match.path}/case/:id/:type`} component={InformationDetails.Page} />
            </>
        )}
    />
);
